<template>
  <div :class="{ mobile: isMobile }">
    <!-- Section title container, including section title for all devices and help accordion toggle button for non-mobile -->
    <div class="section-title-container">
      <h6 class="section-title">
        <slot name="section-title"></slot>
      </h6>
      <fa
        v-if="!isHelpAccordionExpanded && !isMobile"
        icon="question-circle"
        v-tooltip.top="{ content: accordionIconTooltip }"
        @click="isHelpAccordionExpanded = true"
      ></fa>
      <fa
        v-if="isHelpAccordionExpanded && !isMobile"
        icon="chevron-up"
        @click="isHelpAccordionExpanded = false"
      ></fa>
    </div>

    <!-- Help accordion toggle text and button for mobile -->
    <div
      v-if="isMobile"
      class="accordion-toggle"
      @click="isHelpAccordionExpanded = !isHelpAccordionExpanded"
    >
      <p>{{ accordionTitle }}</p>
      <div class="icon-wrapper">
        <fa
          icon="chevron-down"
          :class="{
            'fa-rotate-180': isHelpAccordionExpanded
          }"
        ></fa>
      </div>
    </div>

    <!-- Help accordion content -->
    <div
      ref="accordionBody"
      class="accordion-content"
      :class="{ show: isHelpAccordionExpanded }"
    >
      <h5 v-if="!isMobile">{{ accordionTitle }}</h5>
      <slot name="accordion-content"></slot>
    </div>
  </div>
</template>

<script>
const STANDARD_FONT_SIZE = 16;

export default {
  name: 'SectionTitleAndHelpAccordion',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    accordionIconTooltip: {
      type: String,
      default: 'About this section'
    },
    accordionTitle: {
      type: String,
      default: 'About this section'
    }
  },
  data() {
    return {
      isHelpAccordionExpanded: false
    };
  },
  computed: {},
  watch: {
    isHelpAccordionExpanded: {
      immediate: true,
      handler(val, oldVal) {
        if (!this.$refs.accordionBody) return;

        if (val) {
          this.$refs.accordionBody.style.maxHeight =
            this.$refs.accordionBody.scrollHeight + STANDARD_FONT_SIZE + 'px';
        } else {
          this.$refs.accordionBody.style.maxHeight = 0;
        }
      }
    },
    '$store.state.screenWidth': {
      immediate: true,
      handler(val) {
        // When screenWidth changes and isHelpAccordionExpanded is true, calculate maxHeight of accordionBody dynamically to update the accordion height.
        if (this.isHelpAccordionExpanded) {
          this.$refs.accordionBody.style.maxHeight =
            this.$refs.accordionBody.scrollHeight + STANDARD_FONT_SIZE + 'px';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 2rem 0 1.5rem 0;

  .section-title {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 600;
  }

  svg {
    display: inline-block;
    margin-right: 0.5rem;
    font-size: 1.25rem;
    color: $icon-grey;
    cursor: pointer;
  }
}

.accordion-toggle {
  display: flex;
  align-items: center;
  margin: 0;
  margin-bottom: 1rem;
  width: 15rem;

  p {
    margin: 0;
    border-bottom: 1px solid $text-black;
    cursor: pointer;
  }

  .icon-wrapper {
    padding: 0.5rem;
    padding-right: 1.5rem;
    cursor: pointer;

    svg {
      transition: transform 0.5s;
    }
  }
}

.accordion-content {
  border: none;
  padding: 0;
  opacity: 0;
  height: auto;
  max-height: 0;
  overflow: hidden;
  transition-property: opacity max-height;
  transition-duration: 0.5s;

  &.show {
    padding-top: 1rem;
    margin-bottom: 1rem;
    opacity: 1;
    border-top: 1px solid #bbb;
    border-bottom: 1px solid #bbb;
  }

  h5 {
    margin-bottom: 1rem;
  }
}

.mobile {
  .section-title-container {
    margin-bottom: 1rem;

    .section-title {
      font-size: 1.25rem;
      margin-bottom: 0;
    }
  }

  .accordion-content {
    &.show {
      padding-top: 0;
      border: none;
    }
  }
}
</style>
